import TopicsInput from './TopicsInput'

export default TopicsInput
